import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IntermService } from 'app/services/general/interm.service';
import { Intermv2Service } from 'app/services/general/intermv2.service';

@Component({
  selector: 'app-validacion',
  templateUrl: './validacion.component.html',
  styleUrls: ['./validacion.component.css'],
  providers: [IntermService, Intermv2Service]
})
export class ValidacionComponent implements OnInit {
  registroFm: FormGroup;
  usuario: any;
  tipoDocumentoList = []
  bancoList = []
  paisList = []
  departamentoList = []
  ciudadList = []

  constructor(private fb: FormBuilder, public int:IntermService, public intv2:Intermv2Service, public route: ActivatedRoute) {

  }

  async ngOnInit() {
    // console.log(await this.intv2.paises());
    this.route.paramMap.subscribe(async (resp: any) => {
      this.registroFm = this.fb.group({
        intermediario: this.fb.group({
          idUsuario: [resp.params.id, Validators.required],
          tipoPersona: ['natural', Validators.required],
          idTipoDocumento: [''],
          identificacion: [''],
          nombre: [''],
          direccion: ['', Validators.required],
          idPais: ['', Validators.required],
          idDepartamento: ['', Validators.required],
          idCiudad: ['', Validators.required],
          fechaNacimiento: [''],
          emailFacturacion: ['', [Validators.required, Validators.email]]
        }),
        empresa: this.fb.group({
          razonSocial: [''],
          rutNit: ['']
        }),
        cuentaBancaria: this.fb.group({
          idBanco: [''],
          titularCuenta: [''],
          tipoCuenta: [''],
          numeroCuenta: [''],
          nitCedula: ['']
        }),
        documentos: this.fb.group({
          certificacionBancaria: [''],
          RUT: [''],
          documentoRepresentanteLegal: [''],
          camaraComercio: ['']
        })
      });

      this.usuario = await this.intv2.usuario(resp.params.id);
      this.paisList = await this.intv2.paises();
      this.tipoDocumentoList = await this.intv2.tipoDocumento();
      this.bancoList = await this.intv2.bancos();
    })
  }

  async getDepartamentos(idPais: number) {
    this.departamentoList = await this.intv2.departamentos(idPais);
  }

  async getCiudades(idDepartamento: number) {
    this.ciudadList = await this.intv2.ciudades(idDepartamento);
  }

  onFileChange(event: any, documento: string ) {
    const file = event.target.files[0]
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64string = reader.result as string;
      this.registroFm.get('documentos').get(documento).setValue(base64string)
    }

    if (file) {
      reader.readAsDataURL(file)
    }
  }

  registrarse() {
    // console.log('registrarse')
    // console.log(this.registroFm.value)
    if(this.registroFm.valid) {
      this.intv2.inscribirInt(this.registroFm.value).then(res => {
        alert('Se guardó correctamente')
      }).catch(err => {
        alert('error')
      })
    } else {
      console.log('valide el formulario')
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/intermediarios/validacion/validacion.component.ts